import styled from 'styled-components';
import { Button } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { noStickyHover } from 'styles/noStickyHover.styles';

export const ModalButton = styled(Button)`
  ${noStickyHover}
`;
